import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setShowReportUserPopup } from 'redux-thunk/redux/slices/settings.slice'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import ErrorMessage from 'components/layout/ErrorMessage'
import { LOADER_HANDLER_TYPES } from 'constants/index'
import Loader from 'components/ui-kit/Loader/index'
import { reportUser } from 'redux-thunk/thunk/chat.thunk'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import GoldButton from 'components/ui-kit/GoldButton/index'

const ReportUserPopup = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { userToReport } = useSelector((state) => state.chat)
  const { [LOADER_HANDLER_TYPES.submit]: loading } = useSelector(
    (state) => state.loader
  )

  const modalCloseHandler = () => {
    dispatch(setShowReportUserPopup(false))
  }

  const schema = yup.object().shape({
    description: yup
      .string()
      .required(`${t('descriptionIsRequired')}`)
  })

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'all'
  })

  const handleCancel = () => {
    dispatch(setShowReportUserPopup(false))
  }

  const handleReportUserSubmit = async (values) => {
    dispatch(reportUser({ ...values, reportedUserId: userToReport.id }))
    dispatch(setShowReportUserPopup(false))
  }

  return (
    <CommonPopup
      modalCloseHandler={modalCloseHandler}
      classes='chat-modal tip-modal text-white'
      id='report-user-modal'
      modalDialogClass='max-w-[442px] max-md:m-0 max-md:max-w-full'
      modalBodyClasses='!p-0'
    >
      <h5>
        {t('report')} <span className='color-red'>{userToReport?.name}</span>
      </h5>
      <div className='tip-modal-body'>
        <form onSubmit={handleSubmit(handleReportUserSubmit)}>

          <div className='mb-4 form-group'>
            <div className='mb-2'>
              <label
                htmlFor='description'
                className='form-label text-uppercase'
              >
                {t('description')}
              </label>{' '}
              <span className='color-red'>*</span>
              <input
                type='text'
                placeholder={t('description')}
                className={`box-border w-full h-10 px-3 py-1 text-base text-[var(--white)] bg-[var(--darkGray)] border border-solid border-[var(--darkGray)] rounded-[0.625rem] shadow-none outline-none placeholder:!text-[var(--gray-20)] focus:text-[var(--white)] focus:border-[var(--blue-300)] focus:bg-[var(--darkGray)] focus:outline-none focus:shadow-none focus-within:shadow-none disabled:bg-[var(--gray-90)] disabled:text-[var(--white)] disabled:cursor-not-allowed read-only:bg-[var(--gray-90)] read-only:text-[var(--white)] ${errors?.description ? 'error-input' : ''}`}
                id='description'
                name='description'
                {...register('description')}
              />
              {errors && errors.description && (
                <ErrorMessage
                  className='color-red text-danger error-msg login-input d-flex mt-2'
                  message={errors.description.message}
                />
              )}
            </div>
          </div>
          <div>
            <button
              type='button'
              className='btn btn-primary me-2'
              onClick={handleCancel}
            >
              <span className='text-uppercase'>{t('cancel')}</span>
            </button>
            <GoldButton
              type='submit'
              fullWidth={false}
              disabled={loading}
            >
              {loading
                ? <Loader variant={LOADER_HANDLER_TYPES.submit} />
                : t('report')}
            </GoldButton>
          </div>
        </form>

      </div>
    </CommonPopup>
  )
}

export default React.memo(ReportUserPopup)
